import React, { useRef, useState } from 'react';
import { fileToCompressedBase64 } from '../utils/imageUtils';
import MyteLogo from '../assets/myte-logo.png';

export default function CardCapture({ onCardsAdded }) {
  const fileInputRef = useRef(null);
  const [loadingMsg, setLoadingMsg] = useState('');

  const containerStyle = {
    textAlign: 'center',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  const logoStyle = {
    width: '120px',
    marginBottom: '1rem'
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;

    try {
      const newCards = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        setLoadingMsg(`Compressing ${i + 1} of ${files.length} images...`);
        const b64 = await fileToCompressedBase64(file);
        newCards.push({ imageBase64: b64 });
      }
      // Pass the processed cards up to the parent component
      onCardsAdded(newCards);
      // Reset the input value so users can re-select if needed
      fileInputRef.current.value = '';
    } catch (err) {
      console.error('Error processing images:', err);
      alert('Failed to process images. Please try again.');
    } finally {
      setLoadingMsg('');
    }
  };

  return (
    <div style={containerStyle}>
      <img src={MyteLogo} alt="Myte Logo" style={logoStyle} />
      <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
        Select Business Card(s)
      </h2>
      <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#aaa' }}>
        You can select multiple images from your gallery.
      </p>
      {/* Remove capture attribute to allow gallery selection */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
      />
      {loadingMsg && (
        <p style={{ marginTop: '1rem', color: '#fff', fontWeight: 'bold' }}>
          {loadingMsg}
        </p>
      )}
    </div>
  );
}
